import { render } from "./EditRoleMenu.vue?vue&type=template&id=59a43de4&scoped=true"
import script from "./EditRoleMenu.vue?vue&type=script&lang=js"
export * from "./EditRoleMenu.vue?vue&type=script&lang=js"

import "./EditRoleMenu.vue?vue&type=style&index=0&id=59a43de4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a43de4"]])

export default __exports__